import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const BrandingContext = createContext(null);

// Fallback if API is unreachable
const DEFAULT_BRANDING = {
  display_name: "Magna Mentes",
  tagline: "Field Recruitment OS",
  logo_data_url: null,
};

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/branding");
      setBranding({
        display_name: data.display_name || DEFAULT_BRANDING.display_name,
        tagline: data.tagline ?? DEFAULT_BRANDING.tagline,
        logo_data_url: data.logo_data_url ?? null,
      });
    } catch {
      setBranding(DEFAULT_BRANDING);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => ({ ...branding, loaded, refresh }), [branding, loaded, refresh]);
  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
}

export function useBranding() {
  return useContext(BrandingContext) || { ...DEFAULT_BRANDING, loaded: false, refresh: () => {} };
}
